import type {AxiosPromise} from 'axios';

import {NEWSLETTER} from 'constants/actions';
import type {ActionType} from 'constants/flow/flowTypes';

import type {JoinClubType} from './joinClubType';

export const initialState = {
    status: '',
    redirect: '',
    description: '',
    message: '',
    from: 'from',
};

/**
 * Get join club result from backend
 *
 * @param {JoinClubType} state Current state
 * @param {ActionType<AxiosPromise>} action Received action
 * @returns {JoinClubType} Join club results
 */
export default function joinClub(
    state: JoinClubType = initialState,
    action: ActionType<AxiosPromise>,
): JoinClubType {
    switch (action.type) {
        case `${NEWSLETTER.SUBSCRIBE}_FULFILLED`:
            return {
                ...state,
                ...action.payload.data,
                from: action.meta?.from || '',
                status: 'fulfilled',
            };
        case `${NEWSLETTER.SUBSCRIBE}_PENDING`:
            return {status: 'pending'};
        case `${NEWSLETTER.SUBSCRIBE}_REJECTED`:
            return {...state, ...action.payload.response.data, status: 'rejected'};
        default:
            return state;
    }
}
